import i18n from 'i18next';
import i18nBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import { esTranslation } from '@/lib/i18n/locales/es';

const websiteDomain = process.env.NEXT_PUBLIC_WEBSITE_DOMAIN ?? '';
const useRemoteBackend = Boolean(websiteDomain);

const localResources = {
  es: {
    translation: esTranslation,
  },
};

if (!i18n.isInitialized) {
  const instance = i18n.use(initReactI18next);

  if (useRemoteBackend) {
    instance.use(i18nBackend);
  }

  instance
    .init({
      fallbackLng: 'es',
      lng: 'es',
      resources: useRemoteBackend ? undefined : localResources,
      interpolation: {
        escapeValue: false,
      },
      react: {
        transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p', 'b'],
      },
      backend: useRemoteBackend
        ? {
            loadPath: `${websiteDomain}/i18n/{{lng}}.json`,
            requestOptions: {
              cache: 'no-store',
            },
          }
        : undefined,
    })
    .catch((error) => {
      console.error('Failed to initialise i18n', error);
    });
}

export default i18n;
